// extracted by mini-css-extract-plugin
export default {"wrap":"zK-z","fullWidth":"AK-z","hideOnDesktop":"BK-z","content":"CK-z","hasOpenedNav":"DK-z","crumbsList":"EK-z","dropdownsWrap":"FK-z"};